/**
 * `app-inspection-activity-select` is the shared `app-multiselect` reused inside
 * the dense deficiency tables. The shared control is a full form field (label +
 * validation rows + chip area) and stretches to `w-full`, so in a table cell it
 * comes out too wide and too tall next to the old slim select. These rules keep
 * it scoped-compact without touching the shared multiselect.
 */
export const styles = () => `app-inspection-activity-select {
	display: block;
	width: 100%;
	max-width: 26rem;

	/* No label here and the validation error renders inline, so collapse the
	   form-field grid gaps — matches the old slim single-line select height. */
	& .grid.gap-2 {
		gap: 0;
	}

	/* The error message only exists when invalid; give it a little breathing room. */
	& app-validation-message small {
		margin-top: 0.25rem;
	}

	/* A long single activity must stay inside the cell: wrap within the chip
	   instead of widening the control or overflowing the table. */
	& p-multiselect.customMultiselect {
		width: 100%;
	}

	& .app-chip-item {
		max-width: 100%;
	}
}`;
